import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radar, X } from "lucide-react";
import { api } from "@/lib/api";
import { Panel } from "@/components/core/AppLayout";

export const CompetitorNewsWidget = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin-ai/auto/novita").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  const dismiss = async (it) => { setItems((l) => l.filter((x) => x.analisi_id !== it.analisi_id)); await api.post(`/admin-ai/competitor/${it.analisi_id}/chiudi-novita`).catch(() => {}); };
  return (
    <Panel className="p-6 mb-6" data-testid="dash-competitor-news">
      <h3 className="font-display text-lg font-extrabold text-[#0A1128] flex items-center gap-2 mb-3"><Radar className="h-5 w-5 text-[#E8173A]" />Novità competitor del mese <span className="text-xs font-bold text-[#E8173A]">Solo admin</span></h3>
      <div className="grid gap-2 sm:grid-cols-2">
        {items.map((it) => (
          <div key={it.analisi_id} className="flex items-center gap-2 rounded-xl border border-[#5FB3EA] bg-white/80 px-3 py-2" data-testid={`dash-news-${it.client_id}`}>
            <Link to={`/clienti/${it.client_id}?tab=competitor&analisi=${it.analisi_id}`} className="flex-1 min-w-0 hover:text-[#E8173A]" data-testid={`dash-news-link-${it.client_id}`}>
              <div className="font-bold text-sm truncate">{it.cliente}</div>
              <div className="text-xs text-slate-600">{it.competitor} nuovi competitor · {it.trend} nuovi trend{it.automatica ? " · Automatica · stima AI" : ""}</div>
            </Link>
            <button onClick={() => dismiss(it)} className="rounded-full p-1.5 hover:bg-slate-100" aria-label="Nascondi" data-testid={`dash-news-dismiss-${it.client_id}`}><X className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </Panel>
  );
};
